export default __webpack_public_path__ + "static/media/empty-icon-1.4a32f657.png";